

import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { FaCheckCircle } from "react-icons/fa";
import ConfirmModal from "./../General/Confirmationmodal";

const Withdrawal = () => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);


  const [openModal, setOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [btnLoading, setBtnLoading] = useState(false);

  useEffect(() => {
    fetchHistory();
  }, []);

  const fetchHistory = async () => {
    try {
      const res = await axios.get(
        "https://api.statixtrading.in/api/withdraw-history"
      );

      const formatted = (res.data?.data || []).map((item) => ({
        id: item.id,
        user_name: item.user_name,
        amount: item.amount,
        pay_status: item.pay_status,
        trans_type: item.trans_type,
        pay_on: item.pay_on,
      }));

      setHistory(formatted);
    } catch (error) {
      console.log(error);
      toast.error("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const verifyWithdrawal = async () => {
    try {
      setBtnLoading(true);

      await axios.put(
        `https://api.statixtrading.in/api/verify-withdraw/${selectedId}`
      );

      toast.success("Withdrawal Verified");

   
      setHistory((prev) =>
        prev.map((item) =>
          item.id === selectedId
            ? { ...item, pay_status: "Success" }
            : item
        )
      );

      setOpenModal(false);

    } catch (error) {
      console.log(error);
      toast.error("Verification Failed");
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>
        Withdrawal Requests
      </h2>

      <div style={styles.card}>
        <table style={styles.table}>
          <thead>
            <tr>
              <th style={styles.th}>SN</th>
             <th style={styles.th}>User Name</th>
              <th style={styles.th}>Amount</th>
              <th style={styles.th}>Type</th>
              <th style={styles.th}>Status</th>
              <th style={styles.th}>Date</th>
              <th style={styles.th}>Action</th>
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan="7"
                  style={styles.noData}
                >
                  Loading...
                </td>
              </tr>
            ) : history.length === 0 ? (
              <tr>
                <td
                  colSpan="7"
                  style={styles.noData}
                >
                  No Data Found
                </td>
              </tr>
            ) : (
              history.map((item,index) => (
                <tr key={item.id}>
                  <td style={styles.td}>
                    {index+1}
                  </td>

                  <td style={styles.td}>
                    {item.user_name}
                  </td>

                  <td
                    style={{
                      ...styles.td,
                      fontWeight: "600",
                    }}
                  >
                    ₹ {item.amount}
                  </td>

                  <td style={styles.td}>
                    {item.trans_type}
                  </td>

                  <td
                    style={{
                      ...styles.td,
                      color:
                        item.pay_status === "Success"
                          ? "green"
                          : "#ff9800",
                      fontWeight: "bold",
                    }}
                  >
                    {item.pay_status === "Success"
                      ? "Success"
                      : "Pending"}
                  </td>

                  <td style={styles.td}>
                    {item.pay_on
                      ? new Date(
                          item.pay_on
                        ).toLocaleString()
                      : "-"}
                  </td>

                  <td style={styles.td}>
                    <button
                      onClick={() => {
                        setSelectedId(item.id);
                        setOpenModal(true);
                      }}
                      disabled={
                        item.pay_status ===
                        "Success"
                      }
                      style={{
                        ...styles.verifyBtn,
                        background:
                          item.pay_status ===
                          "Success"
                            ? "#9ca3af"
                            : "#16a34a",
                        cursor:
                          item.pay_status ===
                          "Success"
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      {item.pay_status ===
                      "Success" ? (
                        <>
                          <FaCheckCircle />
                          &nbsp; Verified
                        </>
                      ) : (
                        "Verify"
                      )}
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

 
      <ConfirmModal
        open={openModal}
        title="Verify Withdrawal"
        message="Are you sure you want to verify this withdrawal request?"
        onConfirm={verifyWithdrawal}
        onCancel={() => setOpenModal(false)}
        loading={btnLoading}
      />
    </div>
  );
};

const styles = {
  container: {
    padding: "20px",
    background: "#f4f6f9",
    minHeight: "100vh",
  },

  heading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "20px",
    color: "#1e293b",
    fontSize: "30px",
    fontWeight: "700",
  },

  card: {
    background: "#fff",
    padding: "15px",
    borderRadius: "10px",
    overflowX: "auto",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "900px",
  },

  th: {
    background: "#a8aeb6",
    color: "#fff",
    padding: "12px",
    textAlign: "center",
    fontWeight: "600",
  },

  td: {
    padding: "12px",
    textAlign: "center",
    borderBottom: "1px solid #eee",
    color: "#333",
  },

  verifyBtn: {
    padding: "8px 14px",
    border: "none",
    borderRadius: "6px",
    color: "#fff",
    fontWeight: "600",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    margin: "auto",
  },

  noData: {
    textAlign: "center",
    padding: "20px",
    fontSize: "16px",
    color: "#666",
  },
};

export default Withdrawal;